<template>
    <div class="pageWrap flexCol bgcScN2">
        <div class="pageTop rowJb">
            <div class="topItem" :class="[state == 0 ? 'statusSelect fontMcA1' : 'statusColor']" @click="clickTab(0)">
                待提交 ({{nosubmitTotal}})
                <div class="line bgcMcA1" v-if="state == 0"></div>
            </div>
            <div class="topItem" :class="[state == 1 ? 'statusSelect fontMcA1' : 'statusColor']" @click="clickTab(1)">
                已提交 ({{submitTotal}})
                <div class="line bgcMcA1" v-if="state == 1"></div>
            </div>
        </div>
        <div class="pageSection">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            >
                <van-cell  v-for="(item,index) in taskList" :key="index">
                    <div class="taskModule">
                        <div class="taskDate rowAc">
                            <div class="date">{{item.date}}（日）</div>
                            <div class="circle" v-if="checkDate(item.date)"></div>
                            <div v-if="checkDate(item.date)">{{checkDate(item.date)}}</div>
                        </div>
                        <div class="taskItemBox left" v-for="(item1,index1) in item.list" :key="index1">
                            <div class="taskContent">
                                <div class="taskTitle rowJbAc">
                                    <div class="title textOver">{{item1.title}}</div>
                                    <div class="taskStatus" v-if="state == 1 && item1.isEvaluation == 0">待点评</div>
                                    <div class="taskStatus1" v-if="state == 1 && item1.isEvaluation == 1">已点评</div>
                                </div>
                                <div class="flexRow teacherLine">
                                    <div class="teacher">{{item1.teacherName}}</div>
                                    <div class="publish">发布于</div>
                                    <div class="">{{changeTime(item1.submitDateTime.split(' ')[1],item1.submitDateTime.split(' ')[0])}}</div>
                                </div>
                                <!-- <div class="rowAc taskInfoLine classItem">班级：{{item1.className}}</div> -->
                                <div class="rowAc taskInfoLine">学员：{{item1.studentName}}</div>
                            </div>
                        
                            <div class="submitBtn fontMcA1" @click="clickSubmit(item1)" v-if="state == 0 && item1.isSubmit==1">提交</div>
                            <div class="submitBtn fontMcA1" @click="clickView(item1)" v-if="state == 1">查看</div>
                        </div>
                    </div>
                </van-cell>
                
            </van-list>
        </div>
    </div>
</template>
<script>
import {getTaskPageListAPI} from '../../utils/api/taskApi'
export default {
    name: 'taskList',
    data() {
        return {
            state: 0, // 0 待提交 1：已提交
            pageSize: 10,
            current: 1,
            total: 0,
            taskList: [],
            loading: false,
            finished: false,
            submitTotal: 0, // 已提交总数
            nosubmitTotal: 0, // 待提交总数
            campusCode: '', // 机构code
            parentUid: '', // 
            isCreated: false,
        }
    },
    created() {
        console.log('isCreated',this.state)
        this.isCreated = true
        this.$bus.$emit('pageEvent',{pageName: 'taskList',type: 'add'})
        this.getCampusInfo()
        this.getList(this.state,'')
        this.getList(this.state == 1 ? 0 : 1,'viewTotal')
    },
    beforeRouteLeave(to,from,next) {
        if(to.path == '/taskDetail') {
            // from.meta.keepAlive = true
            this.$bus.$emit('pageEvent',{pageName: 'taskList',type: 'add'})
        }else {
            this.$bus.$emit('pageEvent',{pageName: 'taskList',type: 'del'})
            // from.meta.keepAlive = false
        }
        next()
    },
    activated() {
        if(!this.isCreated) {
            this.current = 1
            this.taskList = []
            this.getList(this.state,'')
            this.getList(this.state == 1 ? 0 : 1,'viewTotal')
        }
    },
    deactivated() {
        this.isCreated = false;
    },
    methods: {
        clickTab(state) {
            if(this.state != state) {
                this.state = state
                this.current = 1
                this.taskList = []
                this.total = 0
                this.getList(this.state,'')
            }
        },
        // 下拉刷新
        onLoad() {
            console.log('---1')
            
            // if(this.dateRangeText) {
                setTimeout(() => {
                    var nowLength = 0 // 当前数组长度
                    this.taskList.forEach(item => {
                        nowLength += item.list.length
                    })
                    if(nowLength >= this.total) {
                        this.finished = true;
                        return
                    }else {
                        this.finished = false;
                    }
                    this.current++
                    this.getList(this.state,'')
                },500)
            // }else {
            //     this.loading = false
            // }
            // console.log('ooo')
            
            
        },
        // 获取校区信息
        getCampusInfo() {
            if(this.$common.getCache('campusItem')) { // 判断本地有无校区信息
                var campusItem = JSON.parse(this.$common.getCache('campusItem'))
                this.parentUid = campusItem.customerId
                this.campusCode = campusItem.campusCode
            }else {
                var campusList = JSON.parse(this.$common.getCache('customerAuthList'))
                if(campusList) {
                    this.campusCode = campusList[0].campusCode
                    this.parentUid = campusList[0].customerId
                }
            }
            
        },
        // 获取列表
        getList(status,type) {
            var obj = {
                currPage: this.current,
                pageSize: this.pageSize,
                status: status,
                parentUid: this.parentUid,
                campusCode: this.campusCode,
            }
            getTaskPageListAPI(obj).then(res => {
                console.log('作业列表：',res)
                if(res.resultCode == 200) {
                    if(status == 0) {
                        this.nosubmitTotal = res.data.totalCount
                    }else {
                        this.submitTotal = res.data.totalCount
                    }
                    if(type == 'viewTotal') {return}
                    this.total = res.data.totalCount
                    if(res.data.dataList) {
                        this.loading = false;
                        res.data.dataList.forEach(item => {
                            var date = item.submitDateTime ? item.submitDateTime.split(' ')[0] : ''
                            var idx = this.taskList.findIndex(taskItem => {return taskItem.date == date})
                            if(idx == -1) {
                                this.taskList.push({
                                    date: date,
                                    list: [JSON.parse(JSON.stringify(item))]
                                })
                            }else {
                                this.taskList[idx].list.push(JSON.parse(JSON.stringify(item)))
                            }
                        });
                        var nowLength = 0 // 当前数组长度
                        this.taskList.forEach(item => {
                            nowLength += item.list.length
                        })
                        if(nowLength == this.total) {
                            this.finished = true;
                            return
                        }else {
                            this.finished = false;
                        }
                    }
                }
                
            })
        },
        // 检查日期
        checkDate(date) {
            var today = new Date()
            var todayStr = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate()
            var yesterday = this.jumpNumDay(new Date(),-1,'-')
            if(this.comparisonDate(todayStr,date)) {
                return '今日'
            }else if(this.comparisonDate(yesterday,date)) {
                return '昨日'
            }else {
                return false
            }
        },
        // 转换时间
        changeTime(time,date1) {
            if(this.checkDate(date1) == '今日') {
                var time1 =  this.getNTimeAfter(time,10)
                var time1Num = Number(time1.split(':')[0]+time1.split(':')[1])
                var date = new Date()
                var nowTime = Number(String(this.changeNum(date.getHours()))+String(this.changeNum(date.getMinutes())))
                if(nowTime < time1Num) {
                    return '刚刚'
                }else {
                    return time.split(':')[0]+":"+time.split(':')[1]
                }
            }else {
                return time.split(':')[0]+":"+time.split(':')[1]
            }  
            
        },
        // 根据开始时间，计算n分钟之后的结束时间
        getNTimeAfter(startTime,n) {
            var endTime = ''
            if(startTime != '') {
                var time = startTime
                var hour = parseInt(time.split(':')[0]) // 开始时间的小时
                var minute = parseInt(time.split(":")[1])  // 开始时间的分钟
                var h = Math.floor(n / 60) // 时长有多少小时
                var m = parseInt(n) % 60 // 时长有多少分钟
                
                if(minute + m >= 60) {
                    hour = hour==23 ? 0 : hour+1 
                    minute = m - (60-minute)
                }else {
                    minute += m
                }
                if(hour + h > 23) {
                    hour = Math.abs(24-(hour+h))
                }else {
                    hour += h
                }
                // console.log('kkkk:',hour,minute,h,m)
                endTime = this.changeNum(hour)+':'+this.changeNum(minute)
            }
            return endTime
        },
        // 对比两个日期是否相等
        comparisonDate(date1,date2) {
            var dateArr1 = date1.split('-')
            var dateArr2 = date2.split('-')
            return dateArr1[0] == dateArr2[0] && Number(dateArr1[1]) == Number(dateArr2[1]) && Number(dateArr1[2]) == Number(dateArr2[2])
        },
        // 向前/向后num天
        jumpNumDay(date,num,linkStr='-') {
            var date1 = new Date(date.getTime()+(num*24*60*60*1000))
            return date1.getFullYear()+linkStr+this.changeNum(date1.getMonth()+1)+linkStr+this.changeNum(date1.getDate())
        },
        // 转换数字
        changeNum(num) {
            if(num >= 10) {
                return num
            }else {
                return '0'+num
            }
        },
        // 点击提交，
        clickSubmit(item) {
            this.$router.push({name: 'SubmitTask',params:{taskInfo: item}})
        },
        // 点击查看
        clickView(item) {
            console.log('查看作业详情---------')
            this.$router.push({name: 'TaskDetail',params:{taskInfo: item,parentUid: this.parentUid}})
        }
    }
}
</script>
<style lang="scss" scoped>
.pageWrap {
    width: 100%;
    height: 100%;
    // background: #F5F6F9;
}
.pageTop {
    height: 0.52rem;
    background: #ffffff;
    padding: 0 .58rem;
    box-sizing: border-box;
    font-size: .16rem;
    line-height: .52rem;
    .topItem {
        position: relative;
        .line {
            position: absolute;
            bottom: 0;
            left: 50%;
            margin-left: -.16rem;
            width: .32rem;
            height: .03rem;
            border-radius: .02rem;
        }
    }
}
.statusColor {
    color: #5A6073;
}
.pageSection {
    padding: .2rem .16rem 0;
    box-sizing: border-box;
    flex: 1;
    overflow: auto;
}
.taskDate {
    font-size: .12rem;
    line-height: .18rem;
    color: #2953FF;
    .date {
        color: #5A6073;
    }
    .circle {
        width: .06rem;
        height: .06rem;
        background: #2953FF;
        border-radius: 50%;
        margin-right: .04rem;
    }
    margin-bottom: 8px;
}
/deep/ .van-cell__value {
    width: 100%;
}
.taskItemBox {
    margin-bottom: .2rem;
    background: #ffffff;
    border-radius: .12rem;
    padding-top: .12rem;
    .taskContent {
        padding: 0 .16rem .12rem;
    }
    .taskTitle {
        line-height: .24rem;
        min-height: .24rem;
        font-size: .16rem;
        font-weight: 500;
        color: #333843;
        margin-bottom: .06rem;
        .title {
            flex: 1;
        }
    }
    .taskStatus {
        width: .58rem;
        height: .25rem;
        line-height: .25rem;
        background: #FFF7E6;
        text-align: center;
        border-radius: .04rem;
        color: #FA8C16;
        font-size: .14rem;
    }
    .taskStatus1 {
        width: .58rem;
        height: .25rem;
        line-height: .25rem;
        background: rgba(15, 206, 140, 0.12);
        text-align: center;
        border-radius: .04rem;
        color: #0FCE8C;
        font-size: .14rem;
    }
    .teacher {
        color: #5A6073;
    }
    .teacherLine {
        font-size: .14rem;
        line-height: .18rem;
        color: #9EA5BB;
        margin: 0 0 .1rem;
        .publish {
            margin: 0 .04rem;
        }
    }
    .classItem {
        margin-bottom: 2px;
    }
    .taskInfoLine {
        font-size: .14rem;
        line-height: .22rem;
        color: #5A6073;
    }
    .submitBtn {
        line-height: .44rem;
        font-size: .16rem;
        text-align: center;
        border-top: 1px solid #E8EBF3;
        // margin-top: .12rem;
    }
}


</style>